import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS } from '@hcr/ui'

import { NavigationAccountButtonWrapper } from '../navigation-account-button-wrapper'

const ButtonColors = {
  STANDARD: COLORS.white,
  HOVER: COLORS.burgundi[450],
  PRESSED: COLORS.burgundi[550],
} as const

interface NavigationAccountButtonUnauthenticatedProps {
  isVisible: boolean
  setIsVisible: (isVisible: boolean) => void
}

export const NavigationAccountButtonUnauthenticated: FC<NavigationAccountButtonUnauthenticatedProps> = ({
  isVisible,
  setIsVisible,
}) => {
  const { t } = useTranslation()

  return (
    <NavigationAccountButtonWrapper
      hoverColor={ButtonColors.HOVER}
      isVisible={isVisible}
      pressedColor={ButtonColors.PRESSED}
      screenReaderPhase={t('navigation.login')}
      setIsVisible={setIsVisible}
      standardColor={ButtonColors.STANDARD}
    >
      <span className='login-text' aria-hidden={true}>
        {t('navigation.login')}
      </span>
    </NavigationAccountButtonWrapper>
  )
}
